import React from 'react';

import {
	ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE,
	LazyHeaderAndFooterPage,
} from '@confluence/site-settings';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminHeaderAndFooterRoute = () => <LazyHeaderAndFooterPage />;

AdminHeaderAndFooterRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
